import { render, staticRenderFns } from "./notes_link_button.vue?vue&type=template&id=36322e6d"
import script from "./notes_link_button.vue?vue&type=script&lang=js"
export * from "./notes_link_button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports